import React from 'react'
// @ts-ignore
import Scrollchor from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'So steht es um Einkommen und Ungleichheit in Ihrer Gemeinde',
    fr: 'La situation des revenus et des inégalités dans votre commune'
  },
  lead: {
    de: (
      <>
        Eine Auswertung der Bundessteuern zeigt, wie es in Ihrer Gemeinde in Bezug auf das Einkommen und die Ungleichheit steht – und ob sich daran in den letzten Jahren etwas geändert hat.
        Wie der Service funktioniert,{' '}
        <Scrollchor to='#methodik'>lesen Sie hier</Scrollchor>.
      </>
    ),
    fr: (
      <>
        Une analyse des impôts fédéraux montre l'écart entre les revenus et l'étendue des inégalités dans la commune – et indique si la situation a évolué au cours des dernières années.
        Le mode de fonctionnement de ce service est{' '}
        <Scrollchor to='#methodik'>expliqué ici</Scrollchor>.
      </>
    )
  },
  feedback: {
    title: {
      de: 'Wie wars?',
      fr: 'Comment jugez-vous ce contenu?'
    },
    questions: {
      de: [
        'Funktionierte die technische Umsetzung?',
        'Wie beurteilen Sie die Textqualität?',
        'Wie beurteilen Sie den Nutzen dieses Textes?'
      ],
      fr: [
        'La mise en oeuvre technique a-t-elle fonctionné?',
        'Comment évaluez-vous la qualité du texte?',
        'Comment évaluez-vous l’utilité du texte?'
      ]
    }
  },
  methodology: {
    title: {
      de: <>Wie dieser Text geschrieben wurde</>,
      fr: <>Comment ce texte est-il écrit?</>
    },
    text: {
      de: (
        <>
          <p>
          Dieser Text wurde basierend auf Daten, die für jede Gemeinde aufbereitet wurden, geschrieben. Die Redaktorinnen und Redaktoren von Tamedia haben einen regelbasierten Algorithmus entworfen, der gemäss den Daten für jede Gemeinde einen individuellen Text schreibt. 
          </p>
          <p>Die Daten stammen <a href="https://www.estv.admin.ch/dam/estv/de/dokumente/allgemein/Dokumentation/Zahlen_fakten/Steuerstatistiken/direkte_bundessteuer/np_statistische_kennzahlen_mit/np_2017.xlsx.download.xlsx/np_2017.xlsx">aus den statistischen Kennzahlen</a> der Eidgenössischen Steuerverwaltung (ESTV). Verwendet werden die Daten für natürliche Personen «mit einer Belastung durch die direkte Bundessteuer». Das «reine Äquivalenzeinkommen» («median_reinka» im Datensatz) bezeichnet dabei eine Kennzahl, mit der Haushalte unterschiedlicher Grösse untereinander verglichen werden können. Siehe dazu die <a href="https://www.estv.admin.ch/dam/estv/de/dokumente/allgemein/Dokumentation/Zahlen_fakten/Steuerstatistiken/direkte_bundessteuer/np_statistische_kennzahlen_mit/Einleitung.pdf.download.pdf/1-Einleitung_NP_d.pdf">Erläuterungen</a> der ESTV. Verwendet wird dabei der <a href="https://de.wikipedia.org/wiki/Median">Median</a>. Der Gini-Index bezieht sich ebenfalls auf das Äquivalenzeinkommen.</p>
        </>
      ),
      fr: (
        <>
          <p>
          Ce texte a été rédigé sur la base des données de chaque municipalité. Les journalistes de Tamedia ont conçu un algorithme basé sur des règles qui génère automatiquement un texte pour chaque commune en fonction de ces données.
          </p>
          <p>Ces dernières proviennent <a href="https://www.estv.admin.ch/dam/estv/de/dokumente/allgemein/Dokumentation/Zahlen_fakten/Steuerstatistiken/direkte_bundessteuer/np_statistische_kennzahlen_mit/np_2017.xlsx.download.xlsx/np_2017.xlsx">des chiffres indicatifs</a> de l'Administration fédérale des contributions (AFC). Les données utilisées sont celles des personnes physiques assujetties à l'impôt fédéral direct. Le «revenu équivalent pur» («median_reinka» dans la série de données) est un chiffre indicatif qui peut être utilisé pour comparer des ménages de tailles différentes. Voir les <a href="https://www.estv.admin.ch/dam/estv/fr/dokumente/allgemein/Dokumentation/Zahlen_fakten/Steuerstatistiken/direkte_bundessteuer/np_statistische_kennzahlen_mit/Einleitung.pdf.download.pdf/2-Introduction_PP_f.pdf">explications</a> de l'AFC. On utilise ici la <a href="https://fr.wikipedia.org/wiki/M%C3%A9diane_(statistiques)">médiane</a> de la commune en question. Le coefficient de Gini fait également référence au revenu équivalent.</p>
        </>
      )
    }
  },
  credits: {
    de: [
      [
        'Umsetzung',
         'Timo Grossenbacher, Titus Plattner und Pavle Djuric'
      ],
      ['Projektleitung', 'Timo Grossenbacher']
    ],
    fr: [
      ['Réalisation', 'Timo Grossenbacher, Titus Plattner et Pavle Djuric'],
      ['Gestion du projet', 'Timo Grossenbacher']
    ]
  },
  municipalitySearchBoxTitle: {
    de: 'Eine andere Gemeinde anzeigen',
    fr: 'Cherchez une autre commune'
  }
}

export default LOCALES
